<template>
  <el-dialog class="alert-dialog" :visible.sync="currentValue" width="422px" title="提示"  :close-on-click-modal="true">
    <div class="alert-dialog-text">
      <i class="icon iconfont icontishi"></i>
      <span>{{title}}</span>
    </div>
    <div class="rest-name-btns">
      <wf-button plain style="margin-right:24px;" @click="currentValue = false">取消</wf-button>
      <wf-button @click="currentValue = false">确定</wf-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['value', 'title'],
  data() {
    return {

    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
}
</script>
<style lang="scss">
.alert-dialog {
  .el-dialog__header{
    border-bottom:0 none;
  }
  .alert-dialog-text {
    font-size: 18px;
    color: rgba(32, 32, 40, 0.8);
    font-weight: 400;
    i {
      color: #ff8b23;
      font-size: 20px;
      margin-right: 8px;
    }
  }
  .rest-name-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 48px;
  }
}
</style>
